'use client';

import { SportMatchModel } from '@nf/types/odds';
import { Button } from '@nf/ui';
import { Icon } from '@/components/icons/svg-icons';
import { useState } from 'react';
import { useAccountInfo } from '@/hooks/query/account';
import { useRouter, usePathname } from '@/navigation';
import { useTranslations } from 'next-intl';
import { useGetSingleMatchPrizeByMatch } from '@/hooks/query/use-promotion-data';
import { siteService } from '@/services/site.service';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { PrizePanel } from '@/components/widgets/prize-panel';
import { useAppearanceStore } from '@/store/appearance';
import { useBreakpoint } from '@/features/breakpoint/contexts';
import { KafkaNote } from '@nf/utils-common/constants';
import { ViewEnum } from '@/types';
import { Breakpoint } from '@/features/breakpoint';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

interface MatchJackpotPanelProps {
	match?: SportMatchModel;
}

export const MatchJackpotPanel = (matchJackpotPanelProps: MatchJackpotPanelProps) => {
	const view = useAppearanceStore(state => state.view);
	const { breakpoint } = useBreakpoint();
	const router = useRouter();
	const pathName = usePathname();
	const { SiteConfigsData } = useGetSiteConfigs();
	const t = useTranslations('General');
	const { match } = matchJackpotPanelProps;
	const { user } = useAccountInfo();
	const { data } = useGetSingleMatchPrizeByMatch(match?.MatchId ?? 0);
	const [isOpen, setIsOpen] = useState(false);
	// const [isSmall, setIsSmall] = useState(false);
	// const topBarHeight = document.querySelector<HTMLElement>('.single-topbar')?.clientHeight;
	// const [streamingType, streamingUrl] = useStreamingStore(
	// 	state => [state.streamingType, state.streamingUrl]
	// );

	// useEffect(() => {
	// 	if (streamingType && streamingUrl) {
	// 		setIsSmall(true);
	// 	} else if (!streamingType && !streamingUrl) {
	// 		setIsSmall(false);
	// 	}
	// }, [streamingType, streamingUrl]);

	if (!match) {
		return;
	}

	const handleClickTips = () => {
		const kafkaData = {
			note: KafkaNote.EPLJackpot,
			type: view == ViewEnum.mars ? 2 : 1,
			action: breakpoint <= Breakpoint.sm ? 10 : 24
		};

		setKafkaNormal(kafkaData);
		setIsOpen(!isOpen);
	}

	const visitJackPot = () => {
		const kafkaData = {
			note: KafkaNote.EPLJackpot,
			type: view == ViewEnum.mars ? 2 : 1,
			action: breakpoint <= Breakpoint.sm ? 9 : 23
		};

		setKafkaNormal(kafkaData);

		localStorage.setItem('jackPotRouter', pathName);
		router.push('/promotion/jackpot/1');
	}

	return (
		<>
			<div className="jackpot-pool">
				<div className="jackpot-pool__container">
					<div className="jackpot-pool__icon">
						<img src={siteService.combineImagePath('/images/promotion/jackpot-epl-icon.png', true, SiteConfigsData)} />
					</div>
					<div
						className="jackpot-pool__info"
						onClick={visitJackPot}
					>
						<div className="jackpot-pool__title">
							{t('lbl_ECPCSJackpotPool')}
						</div>
					</div>
					<div className="jackpot-prize">
						<PrizePanel
							totalPrize={(data?.TotalPrize ?? 0) / (user?.JackPotExchangeRate ?? 1)}
							containerClassName="jackpot-prize__money"
							charClassName="jackpot-prize__char"
							cacheTimeByMinute={2}
							isNeedUpdate={false}
						/>
						<div className="jackpot-prize__currency">SBC</div>
					</div>
					<div
						className="jackpot-pool__tip"
						data-open={isOpen}
					>
						<Button
							variant={'icon'}
							onClick={handleClickTips}
						>
							<Icon name="epl-jackpot-info" />
						</Button>
						<div className="tip tip--detail tip--right" data-open={isOpen}>
							<div className="scrollbar scrollbar--tip">
								<div className="tip__content">
									<div className="text-title">{t('lbl_ECPRRhowToUse')}</div>
									<ul>
										<li>{t('lbl_ECPRRJackpotSingleCSUsageGuide01')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSUsageGuide02')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSUsageGuide03')}</li>
									</ul>
									<div className="text-title">{t('lbl_ECPRRTermsAndRules')}</div>
									<ul>
										<li>{t('lbl_ECPRRJackpotSingleCSTerms01')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSTerms02')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSTerms03')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSTerms04')}</li>
										<li>{t('lbl_ECPRRJackpotSingleCSTerms05')}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}